import PropTypes from 'prop-types';
import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import styles from '../styles.css';

const BrandInfoDisplay = ({ markup }) => (
	<div className={styles['topic-container']}>
		<Scrollbars>
			{/* eslint-disable react/no-danger */}
			<div dangerouslySetInnerHTML={{ __html: markup }} />
			{/* eslint-enable react/no-danger */}
		</Scrollbars>
	</div>
);

BrandInfoDisplay.propTypes = {
	markup: PropTypes.string.isRequired,
};

export default BrandInfoDisplay;
